const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8050';

export const recordAuditEvent = async (eventName, context = {}) => {
  const response = await fetch(`${API_BASE_URL}/api/v1/audit/events`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ event_name: eventName, context })
  });

  if (!response.ok && response.status !== 401) {
    throw new Error(`Unable to record audit event: ${eventName}`);
  }
};
